module.exports = "/_next/static/chromiums/twitter-512x512-products-peach-blossom-lip-balm-7cd349bdc99a1b70913eb5a2560df0b2.jpg";